import { render, staticRenderFns } from "./OwalScrollContainer.vue?vue&type=template&id=0b2117be&scoped=true"
import script from "./OwalScrollContainer.vue?vue&type=script&lang=js"
export * from "./OwalScrollContainer.vue?vue&type=script&lang=js"
import style0 from "./OwalScrollContainer.vue?vue&type=style&index=0&id=0b2117be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2117be",
  null
  
)

export default component.exports